import { Row, Col, Container, Spacing, TypographyElement, Skeleton } from 'UI'
import { createUseStyles } from 'react-jss'
import CoursesList from '../CoursesList'
import LearningPathDescription from '../LearningPathDescription'
import style from './style'
import Text from './text.json'
import Projects from 'components/Course/Projects'
import { projectSectionFeature } from 'constants/'

const useStyles = createUseStyles(style)

export default ({
  loading,
  scrollToPricing,
  learningPathId,
  learningPathProjects,
  ProfileType
}) => {
  const { container, main } = useStyles()

  return (
    <Container className={container}>
      <Row repeatCols={8} mrepeatCols={12} srepeatCols={12}>
        <Col grid={8} mgrid={12} sgrid={12} direction='column'>
          <div className={main}>
            {projectSectionFeature
              ? <Projects
                  learningPathId={learningPathId}
                  learningPathProjects={learningPathProjects}
                  ProfileType={ProfileType}
                  loading={loading}
                  isLearningPath
                  margin={Spacing(0, 0, 5, 0)}
                  padding={Spacing(5)}
                  scrollToPricing={scrollToPricing}
                />
              : null}
            <LearningPathDescription />
            {loading
              ? <Skeleton width='40%' height={50} margin={Spacing(6, 0, 5, 0)} />
              : <TypographyElement Component='h2' variant='heading2' spacing={Spacing(6, 0, 5, 0)}>{Text.learningPathPlan}</TypographyElement>}
            <CoursesList parentIsLoading={loading} />
          </div>
        </Col>
      </Row>
    </Container>
  )
}
